import axiosInstance from '../helpers/axios';
import { getToken } from './auth';

// Get process
export const getProcesses = async (idSubbias, biasId) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/bias/process/?subbias=${idSubbias}&bias__id=${biasId}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get processs' info
export const getProcessInfo = async (idProcess) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/bias/process/${idProcess}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get subbias process by area name
export const getSubbiasProcessByArea = async (idSubbias, area) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/bias/process/?subbias=${idSubbias}&search=${area}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Register process
export const registerProcess = async (data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/bias/process/create/',
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Update process
export const updateProcess = async (data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'put',
		url: `/api/bias/process/update/${data.id}`,
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Delete process
export const deleteProcess = async (idProcess, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'delete',
		url: `/api/bias/process/${idProcess}`,
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};
